import React, { useEffect, useState } from "react";
import { dashboardData } from "./Components/DashboardData";
import ArrivalDepartureReport from "./Tabs/ArriavalDeparture";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_ALL_MAIN_REPORTS_REQUEST,
  GET_FINANCIAL_REPORTS_REQUEST,
  GET_OFFICE_REPORTS_REQUEST,
} from "../../../Utils/Constant";
import InHouseGuestReport from "./Tabs/InHouseGuest";
import GuestFolioReport from "./Tabs/GuestFolio";
import RevenueDashReport from "./Tabs/RevenueDashReport";
import DateSelector from "./Components/DateSelector";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import NightAuditModal from "../Settings/NightAudit/NightAuditModal";
import { getBaseUrl } from "../../../Redux/Config/AppConfig";
import axios from "axios";
import { useHotel } from "../../../Common/HotelContext";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const [activeTab, setActiveTab] = useState("arrivals");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categoryData, setCategoryData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [arrivalList, setArrivalList] = useState([]);
  const [departureList, setDepartureList] = useState([]);
  const [inHouseGuest, setInHouseGuest] = useState([]);
  const [guestFolio, setGuestFolio] = useState([]);
  const [dashBoardData, setDashBoardData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [granularity, setGranularity] = useState("day");
  const [isLoading, setIsLoading] = useState(true);

  // financial report state

  const [dailyRevenueList, setDailyRevenueList] = useState([]);
  const [summaryRevenue, setSummaryRevenue] = useState({});

  const { frontDeskReport, financialReport, mainReports } = useSelector(
    (state) => state.dashBoard
  );

  // Get user from Redux auth state
  let role = localStorage.getItem("role");
  const isAdmin = role === "admin";

  // Use HotelContext
  const {
    hotels,
    selectedHotel,
    setSelectedHotel,
    setSelectedHotelName,
    setSelectedHotelUrl,
    loading: hotelsLoading,
  } = useHotel();

  // Night Audit Preview Modal State
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewReport, setPreviewReport] = useState(null);
  const [previewErrors, setPreviewErrors] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  // Night Audit State
  const [auditDate, setAuditDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [isAuditRunning, setIsAuditRunning] = useState(false);
  const [auditMessage, setAuditMessage] = useState(null);
  const [auditMessageType, setAuditMessageType] = useState("success");
  const [showAuditModal, setShowAuditModal] = useState(false);

  const BaseUrl = getBaseUrl();

  // Fetch preview data on mount
  useEffect(() => {
    if (!selectedHotel && isAdmin || !isAdmin) return;
    const fetchPreview = async () => {
      setPreviewLoading(true);
      try {
        let token = localStorage.getItem("token");
        const res = await fetch(
          `${BaseUrl}/night-audit/preview?hotel_id=${selectedHotel}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // method: 'POST',
            // body: JSON.stringify({ hotel_id: selectedHotel })
          }
        );
        const data = await res.json();
        if (data.success) {
          setPreviewReport(data?.data?.report || null);
          setPreviewErrors(data?.data?.errors || null);
        } else {
          setPreviewReport(null);
          setPreviewErrors([
            { type: "API", message: data.error || "Unknown error" },
          ]);
        }
      } catch (e) {
        setPreviewReport(null);
        setPreviewErrors([{ type: "API", message: e.message }]);
      } finally {
        setPreviewLoading(false);
      }
    };
    fetchPreview();
  }, [BaseUrl, selectedHotel, isAdmin]);

  // Just open modal on click
  const handlePreview = () => {
    setShowPreviewModal(true);
  };

  // Night Audit Functions
  const runNightAudit = async () => {
    setIsAuditRunning(true);
    setAuditMessage(null);
    setShowAuditModal(false);

    try {
      let token = localStorage.getItem("token");
      let hotel_id = localStorage.getItem("hotel_id");

      const response = await fetch(`${BaseUrl}/night-audit/run`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ auditDate, hotel_id }),
      });
      const result = await response.json();

      if (result.success) {
        setAuditMessage("Night audit completed successfully!");
        setAuditMessageType("success");

        // Re-fetch preview data after successful night audit
        setPreviewLoading(true);
        try {
          const previewRes = await fetch(
            `${BaseUrl}/night-audit/preview?hotel_id=${selectedHotel}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const previewData = await previewRes.json();
          if (previewData.success) {
            setPreviewReport(previewData?.data?.report || null);
            setPreviewErrors(previewData?.data?.errors || null);
          } else {
            setPreviewReport(null);
            setPreviewErrors([
              { type: "API", message: previewData.error || "Unknown error" },
            ]);
          }
        } catch (previewError) {
          setPreviewReport(null);
          setPreviewErrors([{ type: "API", message: previewError.message }]);
        } finally {
          setPreviewLoading(false);
        }
      } else {
        setAuditMessage(
          "Night audit failed: " + (result.error || "Unknown error")
        );
        setAuditMessageType("error");
      }
    } catch (error) {
      setAuditMessage("Night audit failed: " + error.message);
      setAuditMessageType("error");
    } finally {
      setTimeout(() => {
        setIsAuditRunning(false);
      }, 1000);
    }
  };

  const handleRunAudit = () => {
    setShowAuditModal(true);
  };

  // Loader logic: show loader if mainReports is not available or empty
  const isMainReportsLoading =
    !mainReports || Object.keys(mainReports).length === 0;

  useEffect(() => {
    setDailyRevenueList(financialReport?.data?.daily_revenue_report || []);
    setSummaryRevenue(financialReport?.data?.summary || {});
    setArrivalList(frontDeskReport?.data?.arrival_list || []);
    setDepartureList(frontDeskReport?.data?.departure_list || []);
    setInHouseGuest(frontDeskReport?.data?.in_house_guests || []);
    setGuestFolio(frontDeskReport?.data?.guest_folios || []);
    setDashBoardData(
      dashboardData?.map((card) => ({
        title: card.title,
        value: `${card.prefix}${mainReports[card.key]}`,
        text: card.text,
        per: `${parseFloat(mainReports[card.changeKey])}%`,
        bg_color: card.bg_color,
      }))
    );
  }, [frontDeskReport, financialReport, mainReports]);

  // Set loading to false when mainReports is loaded
  useEffect(() => {
    if (mainReports && Object.keys(mainReports).length > 0) {
      setIsLoading(false);
    }
  }, [mainReports]);

  const tabs = [
    { key: "arrivals", label: "Arrivals & Departures" },
    { key: "inhouse", label: "In-House Guests" },
    // { key: "roomstatus", label: "Room Status" },
    { key: "guestfolio", label: "Guest Folio" },
    isAdmin && { key: "revenue", label: "Revenue" },
  ];

  // Helper to get ISO week number from a Date
  function getISOWeekNumber(date) {
    const tmp = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    const dayNum = tmp.getUTCDay() || 7;
    tmp.setUTCDate(tmp.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
    return Math.ceil(((tmp - yearStart) / 86400000 + 1) / 7);
  }

  // Robust ISO week calculation with input validation
  function getStartAndEndOfISOWeek(isoWeekString) {
    if (!isoWeekString || !isoWeekString.includes("-W")) {
      // Fallback: use current week
      const now = new Date();
      const year = now.getUTCFullYear();
      const week = getISOWeekNumber(now);
      isoWeekString = `${year}-W${String(week).padStart(2, "0")}`;
    }
    const [yearStr, weekStr] = isoWeekString.split("-W");
    const year = Number(yearStr);
    const week = Number(weekStr);

    if (!year || !week) {
      // Fallback: use current week
      const now = new Date();
      const year = now.getUTCFullYear();
      const week = getISOWeekNumber(now);
      return getStartAndEndOfISOWeek(
        `${year}-W${String(week).padStart(2, "0")}`
      );
    }

    // Jan 4th is always in week 1 (ISO)
    const jan4 = new Date(Date.UTC(year, 0, 4));
    const jan4DayOfWeek = jan4.getUTCDay() || 7; // treat Sunday as 7
    const mondayOfWeek1 = new Date(jan4);
    mondayOfWeek1.setUTCDate(jan4.getUTCDate() - (jan4DayOfWeek - 1));
    const monday = new Date(mondayOfWeek1);
    monday.setUTCDate(mondayOfWeek1.getUTCDate() + (week - 1) * 7);
    monday.setUTCHours(0, 0, 0, 0);
    const sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);
    sunday.setUTCHours(23, 59, 59, 999);
    return {
      startDate: monday.toISOString(),
      endDate: sunday.toISOString(),
    };
  }

  function getStartAndEndOfMonth(yyyyMM) {
    const [year, month] = yyyyMM.split("-").map(Number);
    const startDate = new Date(year, month - 1, 1, 0, 0, 0, 0);
    const endDate = new Date(year, month, 0, 23, 59, 59, 999);
    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  }

  function getStartAndEndOfYear(yyyy) {
    const year = Number(yyyy);
    const startDate = new Date(year, 0, 1, 0, 0, 0, 0);
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999);
    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  }

  const hotel_id = localStorage.getItem("hotel_id");
  useEffect(() => {
    // Calculate startDate and endDate based on granularity and selectedDate
    let startDate = selectedDate;
    let endDate = selectedDate;
    let filterType = granularity;
    if (hotel_id) {
      if (granularity === "week") {
        const { startDate: s, endDate: e } =
          getStartAndEndOfISOWeek(selectedDate);
        startDate = s;
        endDate = e;
      } else if (granularity === "month") {
        const { startDate: s, endDate: e } =
          getStartAndEndOfMonth(selectedDate);
        startDate = s;
        endDate = e;
      } else if (granularity === "year") {
        const { startDate: s, endDate: e } = getStartAndEndOfYear(
          selectedDate.slice(0, 4)
        );
        startDate = s;
        endDate = e;
      } else if (
        granularity === "custom" &&
        selectedDate.from &&
        selectedDate.to
      ) {
        startDate = selectedDate.from + "T00:00:00";
        endDate = selectedDate.to + "T23:59:59";
      } else {
        // Day granularity
        startDate = selectedDate + "T00:00:00";
        endDate = selectedDate + "T23:59:59";
      }

      // Only dispatch if not custom, or if custom and both dates are selected
      const shouldDispatch =
        granularity !== "custom" ||
        (granularity === "custom" &&
          selectedDate &&
          selectedDate.from &&
          selectedDate.to);
      if (!shouldDispatch) return;

      dispatch({
        type: GET_OFFICE_REPORTS_REQUEST,
        payload: {
          page,
          limit: pageSize,
          sortBy,
          sortOrder,
          name: globalFilter,
          startDate,
          endDate,
          filterType,
          hotel_id: selectedHotel ? selectedHotel : hotel_id,
        },
      });
    }
  }, [
    selectedDate,
    granularity,
    page,
    pageSize,
    sortBy,
    sortOrder,
    globalFilter,
    hotel_id,
    selectedHotel,
  ]);

  useEffect(() => {
    // Calculate startDate and endDate based on granularity and selectedDate
    let startDate = selectedDate;
    let endDate = selectedDate;
    let filterType = granularity;

    if (hotel_id && isAdmin) {
      if (granularity === "week") {
        const { startDate: s, endDate: e } =
          getStartAndEndOfISOWeek(selectedDate);
        startDate = s;
        endDate = e;
      } else if (granularity === "month") {
        const { startDate: s, endDate: e } =
          getStartAndEndOfMonth(selectedDate);
        startDate = s;
        endDate = e;
      } else if (granularity === "year") {
        const { startDate: s, endDate: e } = getStartAndEndOfYear(
          selectedDate.slice(0, 4)
        );
        startDate = s;
        endDate = e;
      } else if (
        granularity === "custom" &&
        selectedDate.from &&
        selectedDate.to
      ) {
        startDate = selectedDate.from;
        endDate = selectedDate.to;
      }

      // Only dispatch if not custom, or if custom and both dates are selected
      const shouldDispatch =
        granularity !== "custom" ||
        (granularity === "custom" &&
          selectedDate &&
          selectedDate.from &&
          selectedDate.to);
      if (!shouldDispatch) return;

      dispatch({
        type: GET_FINANCIAL_REPORTS_REQUEST,
        payload: {
          page,
          limit: pageSize,
          sortBy,
          sortOrder,
          name: globalFilter,
          startDate,
          endDate,
          filterType,
          hotel_id: selectedHotel ? selectedHotel : hotel_id,
        },
      });
    }
  }, [
    selectedDate,
    granularity,
    page,
    pageSize,
    sortBy,
    sortOrder,
    globalFilter,
    hotel_id,
    selectedHotel,
  ]);

  useEffect(() => {
    // Calculate startDate and endDate based on granularity and selectedDate
    let startDate = selectedDate;
    let endDate = selectedDate;
    let filterType = granularity;
    if (hotel_id) {
      if (granularity === "week") {
        const { startDate: s, endDate: e } =
          getStartAndEndOfISOWeek(selectedDate);
        startDate = s;
        endDate = e;
      } else if (granularity === "month") {
        const { startDate: s, endDate: e } =
          getStartAndEndOfMonth(selectedDate);
        startDate = s;
        endDate = e;
      } else if (granularity === "year") {
        const { startDate: s, endDate: e } = getStartAndEndOfYear(
          selectedDate.slice(0, 4)
        );
        startDate = s;
        endDate = e;
      } else if (
        granularity === "custom" &&
        selectedDate.from &&
        selectedDate.to
      ) {
        startDate = selectedDate.from;
        endDate = selectedDate.to;
      }

      // Only dispatch if not custom, or if custom and both dates are selected
      const shouldDispatch =
        granularity !== "custom" ||
        (granularity === "custom" &&
          selectedDate &&
          selectedDate.from &&
          selectedDate.to);
      if (!shouldDispatch) return;

      dispatch({
        type: GET_ALL_MAIN_REPORTS_REQUEST,
        payload: {
          page,
          limit: pageSize,
          path: "dashboard",
          startDate,
          endDate,
          filterType,
          hotel_id: selectedHotel ? selectedHotel : hotel_id,
        },
      });
    }
  }, [selectedDate, granularity, page, pageSize, hotel_id, selectedHotel]);

  // Error count for button
  const errorCount = Array.isArray(previewErrors) ? previewErrors.length : 0;

  const handleAIReport = () => {
    const url = localStorage.getItem("url");
    if (url) {
      window.open(url, "_blank"); // ✅ Opens in a new tab
    }
  };
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div>
        {/* Hotel selection dropdown for admin */}
        {isAdmin && (
          <div className="mb-3 text-end">
            <label className="me-2 fw-semibold">Hotel:</label>
            <select
              className="form-select d-inline-block w-auto"
              value={selectedHotel || ""}
              onChange={(e) => {
                setSelectedHotel(e.target.value);
                setSelectedHotelName(
                  hotels?.find((item) => item.id === e.target.value)?.name
                );
                setSelectedHotelUrl(
                  hotels?.find((item) => item.id === e.target.value)?.url
                );
              }}
              disabled={hotelsLoading}
              style={{ minWidth: 200 }}
            >
              {hotels.map((hotel) => (
                <option key={hotel.id} value={hotel.id}>
                  {hotel.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
      <div className="d-flex align-items-center justify-content-between">
        {/* Date Selector */}
        <DateSelector
          value={selectedDate}
          granularity={granularity}
          onChange={(date, gran) => {
            setIsLoading(true);
            setSelectedDate(date);
            setGranularity(gran);
          }}
        />
        {/* Preview Button for Admin */}
        {isAdmin && (
          <div className="mb-3 text-end d-flex gap-2">
            <div style={{ position: "relative", display: "inline-block" }}>
              <button
                className="btn btn-warning btn-sm fw-bold position-relative"
                onClick={handlePreview}
                disabled={previewLoading}
              >
                <i className="bi bi-eye me-1"></i>
                {previewLoading ? "Loading..." : "Night Audit Report"}
                {errorCount > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: "0.8em" }}
                  >
                    {errorCount}
                    <span className="visually-hidden">errors</span>
                  </span>
                )}
              </button>
            </div>
            <div style={{ position: "relative", display: "inline-block" }}>
              <button
                className="btn btn-success btn-sm fw-bold position-relative"
                onClick={handleRunAudit}
                disabled={isAuditRunning}
              >
                <i className="bi bi-moon-stars me-1"></i>
                {isAuditRunning ? "Running..." : "Night Audit"}
              </button>
            </div>
            <div style={{ position: "relative", display: "inline-block" }}>
              <button
                className="btn btn-primary btn-sm fw-bold position-relative"
                onClick={handleAIReport}
                disabled={previewLoading}
              >
                <i className="bi bi-cpu me-1"></i>
                {previewLoading ? "Loading..." : "AI Report"}
              </button>
            </div>
          </div>
        )}
      </div>
      {isLoading ? (
        <>
          <div className="row g-3 mb-3">
            {[...Array(4)].map((_, idx) => (
              <div className="col-md-6 col-lg-3" key={idx}>
                <div className="card">
                  <div className="card-header">
                    <h6 className="card-title mb-0">
                      <Skeleton width={100} height={20} />
                    </h6>
                  </div>
                  <div className="card-body">
                    <h2>
                      <Skeleton width={60} height={36} />
                    </h2>
                    <span className="badge">
                      <Skeleton width={40} height={20} />
                    </span>
                    <span className="text-muted ms-2">
                      <Skeleton width={60} height={16} />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="custom-tabs">
                    {[...Array(4)].map((_, idx) => (
                      <Skeleton
                        key={idx}
                        width={120}
                        height={32}
                        style={{ marginRight: 8 }}
                      />
                    ))}
                  </div>
                </div>
                <div className="card-body">
                  <Skeleton height={300} />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="row g-3 mb-3">
            {isAdmin && dashBoardData?.length
              ? dashBoardData?.map((data, index) => (
                  <div className="col-md-6 col-lg-3" key={index}>
                    <div className="card">
                      <div className="card-header">
                        <h6 className="card-title mb-0">{data.title}</h6>
                      </div>
                      <div className="card-body">
                        <h2>{data.value}</h2>
                        <span className={`badge ${data.bg_color}`}>
                          {data.per}
                        </span>
                        <span className="text-muted"> {data.text}</span>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </div>

          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  {/* <h6 className="card-title mb-0">Reservations</h6> */}
                  <div className="custom-tabs">
                    {tabs.map((tab) => (
                      <button
                        key={tab.key}
                        className={`tab-btn ${
                          activeTab === tab.key ? "active" : ""
                        }`}
                        onClick={() => setActiveTab(tab.key)}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="card-body">
                  {activeTab === "arrivals" && (
                    <ArrivalDepartureReport
                      arrivalList={arrivalList}
                      departureList={departureList}
                      selectedDate={selectedDate}
                      granularity={granularity}
                    />
                  )}
                  {activeTab === "inhouse" && (
                    <InHouseGuestReport
                      inHouseGuest={inHouseGuest}
                      selectedDate={selectedDate}
                      granularity={granularity}
                    />
                  )}
                  {activeTab === "roomstatus" && (
                    <h5>Room Status (Coming Soon)</h5>
                  )}
                  {activeTab === "guestfolio" && (
                    <GuestFolioReport
                      guestFolio={guestFolio}
                      selectedDate={selectedDate}
                      granularity={granularity}
                    />
                  )}
                  {activeTab === "revenue" && (
                    <RevenueDashReport
                      dailyRevenueList={dailyRevenueList}
                      summaryRevenue={summaryRevenue}
                      selectedDate={selectedDate}
                      granularity={granularity}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Optional Booking Table Section
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h6 className="card-title">Today Booking List</h6>
            </div>
            <div className="card-body">
              <BookingTable />
            </div>
          </div>
        </div>
      </div>
      */}
      <NightAuditModal
        open={showPreviewModal}
        onClose={() => setShowPreviewModal(false)}
        report={previewReport}
        errors={previewErrors}
      />

      {/* Night Audit Modal */}
      {showAuditModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  <i className="bi bi-moon-stars me-2"></i>
                  Night Audit
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowAuditModal(false)}
                  disabled={isAuditRunning}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  <strong>Important:</strong> Night audit will process all daily
                  transactions and update system records. This operation cannot
                  be undone.
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Select Audit Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={auditDate}
                    onChange={(e) => setAuditDate(e.target.value)}
                    disabled={isAuditRunning}
                    max={new Date().toISOString().slice(0, 10)}
                  />
                  <small className="text-muted">
                    Selected date:{" "}
                    {new Date(auditDate).toLocaleDateString("en-US", {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </small>
                </div>

                {auditMessage && (
                  <div
                    className={`alert alert-${
                      auditMessageType === "success" ? "success" : "danger"
                    }`}
                  >
                    {auditMessage}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowAuditModal(false)}
                  disabled={isAuditRunning}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn ${
                    isAuditRunning ? "btn-secondary" : "btn-success"
                  }`}
                  onClick={runNightAudit}
                  disabled={isAuditRunning}
                >
                  {isAuditRunning ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      Running Audit...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-play-circle-fill me-2"></i>
                      Run Night Audit
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop */}
      {showAuditModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Index;
